
import React from "react";
import IWrapText from "./interface";
import ComponentWrapText from "./styles";

/**
 * Help to not overflow the phrase
 * @param lineClamp number of lines to hide the phrase
 * @param bold make the text bold
 * @param styleInline your style that overlaps the current
 * @param title to show text on hover
 */
const WrapText: React.FC<IWrapText> = ({children, ...rest}) => <ComponentWrapText {...rest}>{children || ""}</ComponentWrapText> ;

export default WrapText;
